<template>
	  <path
    d="M8.00004 3.33333V8M8.00004 8H10.6667C11.7713 8 12.6667 8.89543 12.6667 9.99999V12.6667M8.00004 8H5.33337C4.2288 8 3.33337 8.89543 3.33337 9.99999V12.6667"
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <circle cx="7.99992" cy="3.33334" r="1.66667" fill="currentColor" />
  <circle cx="12.6667" cy="12.6667" r="1.66667" fill="currentColor" />
  <ellipse cx="3.33329" cy="12.6667" rx="1.66667" ry="1.66667" fill="currentColor" />
</template>
